<template>
    <div v-if="reviews.length === 0" class="flex flex-center">
        <p class="font-thin text-xl text-gray-500 text-center">
            Denne influencer har endnu ikke nogle anbefaliner.
        </p>
    </div>

    <div v-else>
        <ReviewCard
            v-for="_review in reviews"
            :key="_review.id"
            :review="_review"
            class="well w-lg"
        >
            <template v-slot:footer="{ review }">
                <hr class="mt-4 mb-0" />

                <a
                    v-if="review.reviewable.content_url"
                    :href="review.reviewable.content_url"
                    class="btn btn-primary m-4"
                    target="_blank"
                    v-text="'Se opslag'"
                />

                <ContentsGrid
                    v-if="review.reviewable.contents.length > 0"
                    :contents="review.reviewable.contents"
                    class="m-4"
                    content-class="border border-gray-300 rounded-lg bg-gray-100"
                />
            </template>
        </ReviewCard>
    </div>
</template>

<script type="text/babel">
import ReviewCard from 'dashboard-js/components/reviews/ReviewCard'

export default {
    components: { ReviewCard },

    props: ['reviews'],
}
</script>
